import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { paymentAPI } from '../api/payment';
import Loader from '../components/common/Loader';
import toast from 'react-hot-toast';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const [verifying, setVerifying] = useState(true);
  const [verified, setVerified] = useState(false);
  const [orderStatus, setOrderStatus] = useState(null);

  useEffect(() => {
    verifyPayment();
  }, []);

  const verifyPayment = async () => {
    const transactionId = searchParams.get('transaction_id');
    const orderId = searchParams.get('order_id');
    
    const idToVerify = transactionId || orderId;
    
    if (!idToVerify) {
      console.error('No transaction ID or order ID found');
      setVerifying(false);
      toast.error('Payment verification failed');
      return;
    }

    try {
      const result = await paymentAPI.verify(idToVerify);
      
      if (result.verified === true) {
        setVerified(true);
        setOrderStatus(result.order_status || 'paid');
        toast.success('Payment confirmed');
      } else {
        toast.warning('Verifying payment. Your order will be updated shortly.');
        setVerified(true);
      }
    } catch (error) {
      console.error('Verification error:', error);
      toast.error(error.response?.data?.detail || 'Failed to verify payment');
    } finally {
      setVerifying(false);
    }
  };

  if (verifying) return <Loader />;

  return (
    <div className="max-w-lg mx-auto px-6 lg:px-8 py-16 lg:py-20 text-center">
      <CheckCircleIcon className="h-16 w-16 text-green-600 mx-auto mb-5" />
      <h1 className="text-xl lg:text-2xl font-light tracking-tight text-gray-900 mb-2">
        Payment Successful
      </h1>
      <p className="text-sm text-gray-400 mb-8">
        Your order has been confirmed.
      </p>

      {orderStatus && (
        <div className="mb-8">
          <p className="text-xs text-gray-400 uppercase tracking-wider mb-1">
            Order Status
          </p>
          <p className="text-sm text-gray-900 capitalize">
            {orderStatus}
          </p>
        </div>
      )}
      
      <div className="mb-10">
        <p className="text-xs text-gray-400 leading-relaxed">
          You will receive an email confirmation shortly.
        </p>
      </div>
      
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link 
          to="/orders" 
          className="px-6 py-2.5 text-xs font-medium tracking-wide text-white bg-gray-900 hover:bg-gray-800 transition"
        >
          View Orders
        </Link>
        <Link 
          to="/products" 
          className="px-6 py-2.5 text-xs font-medium tracking-wide text-gray-900 border border-gray-200 hover:border-gray-900 transition"
        >
          Continue Shopping
        </Link>
      </div>
    </div>
  );
};

export default PaymentSuccess;